/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');

var PageableCollection = require('psa-backbone/models/PageableCollection');
var GridView = require('psa-marionette/views/GridView');
var UIUtil = require('psa-core/util/ui');

var MultiButtonCell = require('common/backgrid/MultiButtonCell');
var MomentCell = require('common/backgrid/MomentCell');

var GetCorrespondence = require('../../tasks/services/GetCorrespondence.js');
var NonDepCorrespondenceModalView = require('../../correspondence/views/NonDepCorrespondenceModalView');

var tmplNonDepEntityCorrespondenceView = require('../templates/NonDepEntityCorrespondenceView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplNonDepEntityCorrespondenceView,

  className: 'non-dep-entity-correspondence-view',

  ui: {
    correspondenceContainer: '.correspondence-container'
  },

  regions: {
    correspondenceContainer: '@ui.correspondenceContainer'
  },

  onBeforeShow: function() {
    var entityCorrespondenceGrid = new GridView({
      columns: [
        {
          name: 'source',
          label: 'Source',
          cell: 'string',
          headerCell: 'custom',
          width: 12,
          editable: false
        },
        {
          name: 'objectTypeId',
          label: 'Type',
          cell: 'string',
          headerCell: 'custom',
          width: 12,
          editable: false
        },
        {
          name: 'requestedBy',
          label: 'Requested By',
          cell: 'string',
          headerCell: 'custom',
          width: 12,
          editable: false
        },
        {
          name: 'requestedOn',
          label: 'Requested On',
          cell: MomentCell.MomentCell,
          formatter: MomentCell.MomentDateFormatter.extend({
            emptyValue: '--'
          }),
          headerCell: 'custom',
          width: 12,
          editable: false
        },
        {
          name: 'repliedBy',
          label: 'Replied By',
          cell: 'string',
          headerCell: 'custom',
          width: 12,
          editable: false
        },
        {
          name: 'repliedOn',
          label: 'Replied On',
          cell: MomentCell.MomentCell,
          formatter: MomentCell.MomentDateFormatter.extend({
            emptyValue: '--'
          }),
          headerCell: 'custom',
          width: 12,
          editable: false
        },
        {
          name: '',
          cell: MultiButtonCell.extend({
            buttons: [
              {
                name: 'Open',
                buttonClass: 'btn-primary btn-sm view-correspondence-details',
                onClick: this.onClickViewCorrespondence.bind(this)
              }
            ]
          }),
          editable: false,
          sortable: false,
          headerCell: 'custom',
          width: 5
        }
      ],
      collection: new PageableCollection(this.model.get('correspondences'), { pageSize: 10 }),
      emptyText: 'No Related Correspondences'
    });
    this.showChildView('correspondenceContainer', entityCorrespondenceGrid);
  },

  onClickViewCorrespondence: function(e, model) {
    e.preventDefault();
    GetCorrespondence(model.get('id')).done(function(correspondence) {
      correspondence.isInternal = model.get('isInternal');
      UIUtil.showModal({
        title: model.get('isInternal') === '1' ? 'Internal Correspondence Details' : 'External Correspondence Details',
        view: new NonDepCorrespondenceModalView({
          model: new Backbone.Model(correspondence)
        })
      });
    });
  }
});
